/**
 * Where to send the user after the email code (2026-09-24). Both routes to /mfa
 * — the API's MFA_REQUIRED answer (a full page load, so no router state
 * survives) and ProtectedRoute's redirect — remember the page first, and /mfa
 * returns there instead of dropping the user on the home page ("takes me away
 * from the page I was on", Faiz). Same-app paths only.
 *
 * Since 2026-10-09 the sign-in step uses it too: ProtectedRoute remembers the page
 * before sending a signed-out visitor to /login (and the API before a revoked
 * session's /login?revoked=1), and LoginPage goes back there; before, a link
 * opened while signed out always ended on / after the code.
 */
const KEY = 'mavi:mfa:returnTo';

function isSafe(path: string | null | undefined): path is string {
  return !!path && path.startsWith('/') && !path.startsWith('//') && !/^\/(mfa|login)(\/|\?|#|$)/.test(path);
}

export function rememberMfaReturnTo(path: string): void {
  if (!isSafe(path)) return;
  try { sessionStorage.setItem(KEY, path); } catch { /* storage blocked — falls back to home */ }
}

/** The remembered page, or '/' when there is none. */
export function mfaReturnTo(): string {
  try {
    const v = sessionStorage.getItem(KEY);
    return isSafe(v) ? v : '/';
  } catch {
    return '/';
  }
}

export function clearMfaReturnTo(): void {
  try { sessionStorage.removeItem(KEY); } catch { /* ignore */ }
}
